import styled from "styled-components";

export const SpecialPointsContainerStyled = styled.div`
  padding: 20px 18px 104px 18px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .special_points_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    .header_sec {
      display: flex;
    }
    .special_points_layout {
      margin-bottom: 20px;
    }
    .menu_item_wrap {
      margin: auto;
      margin-bottom: 16px;
      max-width: 358px;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 40px 18px 104px 18px;
    .breadcrumb_layout {
      display: none;
    }
    .special_points_container {
      .menu_item_wrap {
        max-width: 300px;
      }
    }
    .special_points_layout {
      display: none;
    }
  }
`;
